//Localhost
export const LOCALHOST = process.env.REACT_APP_URL_LOCAL;

//Auth
export const SIGNIN = '/';

export const EXPIRATIONTOKEN = '/expirationtoken';

export const PAGENOTFOUND = '/*';

//Home
export const HOME = '/';

//Users
export const USERS = '/users';
export const USERLIST = '/users/list';
export const USERNEW = '/users/new';
export const USEREDIT = '/users/edit';

//Chat
export const CHAT = '/chat';
